<template>
    <section id="user-chats">

        <h1><i class="fa fa-fw fa-home"></i> Public Chats</h1>
        <section id="public-list">
            <a v-for="publicChat in PublicChats"
               @click.prevent="switchToChat('public.' + publicChat.id)"
               :class="{selected: chatId === 'public.' + publicChat.id}"
               :key="publicChat.id"
               href="#"
            >
                <span>{{publicChat.alias}}</span>
                <span v-if="publicChat.unreadMessages != 0" class="unread-message-count">{{publicChat.unreadMessages}}</span>
            </a>
        </section>

        <template v-if="addGroupMode">
            <h1><i class="fa fa-fw fa-home"></i> Create a new Group</h1>

            <section id="new-group-form" v-if="addGroupMode">
                <input type="text" placeholder="Group Name..." v-model="newGroupName" :disabled="savingNewGroup"/>
                <div class="button-container">
                    <button @click.prevent="addGroupMode = false" :disabled="savingNewGroup">Cancel</button>
                    <button @click.prevent="createNewGroup" :disabled="savingNewGroup">Create</button>
                </div>
            </section>
        </template>

        <template v-if="!addGroupMode">
            <h1><i class="fa fa-fw fa-group"></i> Group Chats</h1>

            <section id="groups-list">
                <span class="add-group-button">
                    <a href="#" @click.prevent="addGroupMode = true">Create a New Group <i class="fa fa-plus-circle"></i></a>
                </span>

                <a v-for="groupChat in groupChats"
                   @click.prevent="switchToChat('group.' + groupChat.id)"
                   :class="{selected: chatId === 'group.' + groupChat.id}"
                   :key="groupChat.id"
                   href="#"
                >
                    <span>{{groupChat.alias}}</span>
                    <span v-if="groupChat.unreadMessages != 0" class="unread-message-count">{{groupChat.unreadMessages}}</span>
                </a>
            </section>
        </template>


        <template v-if="friendChats.length > 0">
            <h1><i class="fa fa-fw fa-user"></i> Friend Chats</h1>

            <section id="friends-list">
                <a v-for="friendChat in friendChats"
                   @click.prevent="switchToChat('private.' + friendChat.friendChatId)"
                   :class="{selected: chatId === 'private.' + friendChat.friendChatId}"
                   :key="friendChat.friendChatId"
                   href="#"
                >
                    <img class="avatar" :src="generateAvatarImage(friendChat)"></img>
                    <i class="fa fa-circle online-status" v-if="friendChat.isOnline"></i>
                    <span v-if="friendChat.unreadMessages != 0" class="unread-message-count">{{friendChat.unreadMessages}}</span>
                    <span class="friends-list-alias">{{friendChat.alias}}</span>

                    <!--<a :href="`/Profile/${friendChat.stringUrl}`" target="_blank" class="fa fa-user profile-icon"></a>-->
                </a>
            </section>
        </template>
    </section>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'UserChats',
        data () {
            return {
                addGroupMode: false,
                newGroupName: '',
                savingNewGroup: false
            }
        },

        computed: {
            chatId(){
                return this.$store.state.activeChatModel.id;
            },

            PublicChats(){
                return this.$store.state.publicChatsModel.publicChatrooms;
            },

            groupChats(){
                return this.$store.state.groupChatsModel.groupChatrooms;
            },

            friendChats(){
                let friendChats = this.$store.state.friendChatsModel.friendChatrooms;

                friendChats.forEach((friendChat) => {
                    friendChat.isOnline = this.onlineUsers[friendChat.stringUrl] !== undefined;
                });

                friendChats.sort((a, b) => {
                    if (a.unreadMessages > b.unreadMessages) return -1;
                    if (a.unreadMessages < b.unreadMessages) return 1;
                    if (a.isOnline && !b.isOnline) return -1;
                    if (!a.isOnline && b.isOnline) return 1;
                    if (a.alias.toLowerCase() < b.alias.toLowerCase()) return -1;
                    if (a.alias.toLowerCase() > b.alias.toLowerCase()) return 1;
                    return 0;
                });


                return friendChats;
            },

            onlineUsers(){
                return this.$store.state.onlineUsersModel.onlineUsers;
            }
        },

        methods: {
            switchToChat(newChatId){
                this.$store.commit('activeChatModel/setActiveChat', newChatId);
            },

            generateAvatarImage(friend){
                let avatarId = new Date(friend.avatarUpdate).getTime();

                if (friend.hasAvatar) {
                    return `/userdata/avatars/${friend.id}.jpg?v=${avatarId}`
                } else {
                    return '/defaultProfilePic.png';
                }
            },

            isOnline(friend){
                let foundFriend = false;

                this.onlineUsers.forEach(function (onlineUser) {
                    if (onlineUser.id === friend.id) {
                        foundFriend = true;
                        return false;
                    }
                });

                return foundFriend;
            },

            createNewGroup(){
                this.newGroupName = this.newGroupName.trim();

                if (this.newGroupName === '') {
                    return;
                }

                this.savingNewGroup = true;

                axios.post('/api/groups/newGroup', {
                    groupName: this.newGroupName
                }).then(
                    (response) => {
                        this.addGroupMode = false;
                        this.savingNewGroup = false;
                        this.newGroupName = '';
                    }
                );
            }
        },

        mounted(){
            this.$store.dispatch('publicChatsModel/fetchPublicChats');
            this.$store.dispatch('groupChatsModel/fetchGroupChats');
            this.$store.dispatch('friendChatsModel/fetchFriendChats');
        },

        sockets: {
            'updateFriendStatus'(){
                this.$store.dispatch('friendChatsModel/fetchFriendChats');
            },

            'updateGroupChats'(){
                this.$store.dispatch('groupChatsModel/fetchGroupChats');
            },

            'groupDataUpdated'(){
                this.$store.dispatch('groupChatsModel/fetchGroupChats');
            },

            'updateChatRoomList'(data){
                if (data.chatId === this.chatId) {
                    return;
                }

                data.type = data.chatId.split('.')[0];

                if (data.type === 'public') {
                    this.$store.dispatch('publicChatsModel/fetchPublicChats');
                }

                if (data.type === 'group') {
                    this.$store.dispatch('groupChatsModel/fetchGroupChats');
                }

                if (data.type === 'private') {
                    this.$store.dispatch('friendChatsModel/fetchFriendChats');
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// UserChats.vue?41e016fc